import * as PleasedApi from '@/common/api/api.pleased';
import { ChatWarningState, ChatWarnings } from './chatWarning.types';
import { ActionContext } from 'vuex';
import { ChatWarningField } from '@/common/api/models.pleased';
import { isStringBoolean, parseStringBoolean } from '@/common/boolean.utils';

const state: ChatWarningState = {
  chatWarningFields: [],
};

const mutations = {
  setChatWarningFields(state: ChatWarningState, chatWarningFields: ChatWarningField[]) {
    state.chatWarningFields = chatWarningFields;
  },
};

const actions = {
  async fetchChatWarnings({ commit }: ActionContext<ChatWarningState, unknown>) {
    const chatWarnings = await PleasedApi.getChatWarnings();
    commit('setChatWarningFields', chatWarnings);
  },
};

const getters = {
  chatWarnings(state: ChatWarningState): ChatWarnings {
    return state.chatWarningFields.reduce<ChatWarnings>((acc, { configKey, configValue }) => {
      const value = isStringBoolean(configValue) ? parseStringBoolean(configValue) : configValue;

      acc[configKey] = value;
      return acc;
    }, {});
  },
};

const chatWarning = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default chatWarning;
